// import getActiveBlocks from 'services/apiHelpers/getActiveBlocks';
import getModuleImages from 'services/getModuleImages';
import { loadAssets } from 'components/lib/BootScreen';

const loadImgs = images => {
  const img = new Image();
  img.src = images[0];
  img.onload = () => {
    // console.log('LOADED :', img.src);

    // how many images do we want to load ahead of ?
    // right now this makes the assumption of a full page splashy

    const checkLoadImages = setInterval(() => {
      if (loadAssets.loadImages) {
        clearInterval(checkLoadImages);
        loadAssets.loadImages();
      }
    }, 100);

    const [_, ...remaining] = images;
    remaining.length ? loadImgs(remaining) : console.log(`ALL IMAGES LOADED`);
  };
};

const init = blocks => {
  // // const values = Object.values(blocks);

  // // const interactionBackgrounds = values
  // //   .filter(
  // //     (b: any) =>
  // //       b.type === 'Interaction' &&
  // //       b.props.background &&
  // //       b.props.background.includes('url')
  // //   )
  // //   .map((b: any) => b.props.background.split(/url\(|\)/g)[1]);

  // // const images = values
  // //   .filter((b: any) => b.type === 'Image' && b.props.src)
  // //   .map((b: any) => b.props.src);

  // // refactored to below
  // // just looking at different styles ( / ways. to get this written etc )
  // // open the conversation. . .

  // const interactionBackgrounds = [];
  // const images = [];

  // // blocks are being / should be passed in
  // // but just for the now getActiveBlocks() is dirty
  // // until we understand where the error is in prod
  // let blocks_ = blocks;

  // // try {
  // //   blocks_ = getActiveBlocks();
  // // } catch (err) {
  // //   console.log(err);
  // // }

  // Object.values(blocks_).forEach((b: any) => {
  //   // Object.values(getActiveBlocks() as any).forEach((b: any) => {
  //   switch (b.type) {
  //     case 'Interaction': {
  //       b.type === 'Interaction' &&
  //         b.props.background &&
  //         b.props.background.includes('url') &&
  //         // interactionBackgrounds.push(
  //         //   String(b.props.background.match(/(?<=\().*(?=\))/))
  //         // );
  //         // since ie won't have it ^
  //         interactionBackgrounds.push(b.props.background.split(/url\(|\)/g)[1]);
  //     }
  //     case 'Image': {
  //       b.props.src && images.push(b.props.src);
  //     }
  //   }
  // });

  // // console.log('LOADED :', {
  // //   'interactionBackgrounds.length': interactionBackgrounds.length,
  // //   'images.length': images.length,
  // // });

  const compedInteractionBackgroundsImages = getModuleImages();
  // [
  //   ...interactionBackgrounds,
  //   ...images,
  // ];

  if (compedInteractionBackgroundsImages.length) {
    return loadImgs(compedInteractionBackgroundsImages);
  }

  // need to fix this
  // timing issues with the module resolve. WHEN loadImages can be called ( and work )
  const checkLoadImages = setInterval(() => {
    if (loadAssets.loadImages) {
      clearInterval(checkLoadImages);
      loadAssets.loadImages();
    }
  }, 100);
};

export default init;
